import React from "react";

import { somar, filtrarPorModalidade } from "./fechamentoPeriodoUtils.js";

const CAMPOS_FISCALIZACAO = [
  { campo: 'qntBFSLimpa', largura: '14%' },
  { campo: 'qntBFSSujo', largura: '14%' },
  { campo: 'qntBFSCritico', largura: '14%' },
  { campo: 'qntCNC', largura: '12%' },
  { campo: 'qntDentroResp', largura: '20%' },
  { campo: 'qntForaResp', largura: '20%' },
];

function LinhaFiscalizacao({ titulo, valores, qntBFS, qntACIC, negrito, className }) {
  return (
    <tr className={className} style={negrito ? { fontWeight: 'bold' } : undefined}>
      <td>{negrito ? <strong>{titulo}</strong> : titulo}</td>
      <td>
        <table cellSpacing="0" className="bfs_subtable-result">
          <tbody>
            <tr>
              {CAMPOS_FISCALIZACAO.map(({ campo, largura }) => (
                <td key={campo} style={{ width: largura }}>{valores(campo)}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </td>
      <td className="bfs_text-center">{qntBFS}</td>
      <td className="bfs_text-center" style={{ borderRight: '1px solid' }}>{qntACIC}</td>
    </tr>
  );
}

function LinhasModalidade({ lista, tituloSubtotal }) {
  if (lista.length === 0) return null;

  return (
    <>
      {lista.map((tipoServico) => (
        <LinhaFiscalizacao
          key={tipoServico.idTipoServico}
          titulo={tipoServico.tipoServico}
          valores={(campo) => tipoServico[campo]}
          qntBFS={tipoServico.qntBFS}
          qntACIC={tipoServico.qntACIC}
        />
      ))}
      <LinhaFiscalizacao
        negrito
        titulo={tituloSubtotal}
        valores={(campo) => somar(lista, campo)}
        qntBFS={somar(lista, 'qntBFS')}
        qntACIC={somar(lista, 'qntACIC')}
      />
    </>
  );
}

export function Totalizadores({ qntBFS, qntVistorias }) {
  return (
    <table border="1">
      <tbody>
        <tr>
          <td style={{ width: '41.3%' }}><strong>TOTALIZADORES BFS</strong></td>
          <td style={{ width: '19%' }}>
            <table cellSpacing="0" border="1" className="bfs_subtable">
              <tbody>
                <tr>
                  <td>
                    <table cellSpacing="0" className="bfs_subtable">
                      <tbody>
                        <tr>
                          <td width="100%">Totais</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td className="bfs_text-center" style={{ borderRight: '1px solid' }}></td>
        </tr>
        <tr>
          <td>Total de BFS registradas no período</td>
          <td>
            <table cellSpacing="0" className="bfs_subtable-result">
              <tbody>
                <tr>
                  <td width="100%">{qntBFS}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td colSpan="2" style={{ borderRight: '1px solid' }}></td>
        </tr>
        <tr>
          <td>Total de Vistorias registradas no período</td>
          <td>
            <table cellSpacing="0" className="bfs_subtable-result">
              <tbody>
                <tr>
                  <td width="100%">{qntVistorias}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td colSpan="2" style={{ borderRight: '1px solid' }}></td>
        </tr>
      </tbody>
    </table>
  );
}

export default function ResumoOrigem({ titulo, tipoServico, qntTotalBFS, qntTotalVistorias }) {
  const escalonado = filtrarPorModalidade(tipoServico, 'Escalonado');
  const demandante = filtrarPorModalidade(tipoServico, 'Demandante');
  const outros = filtrarPorModalidade(tipoServico, 'Outros Servicos');
  const regulares = escalonado.concat(demandante);

  const totalConforme = somar(outros, 'qntConforme');
  const totalNaoConforme = somar(outros, 'qntNaoConforme');

  return (
    <>
      <div className="bfs_services-title">{titulo}</div>

      <table cellSpacing="0" border="1">
        <thead>
          <tr>
            <th colSpan={10}>Verificação dos Serviços</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>SERVIÇOS</strong></td>
            <td>
              <table cellSpacing="0" border="1" className="bfs_subtable">
                <thead>
                  <tr>
                    <th colSpan="3">FISCALIZAÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <table cellSpacing="0" border="1" className="bfs_subtable">
                        <thead>
                          <tr>
                            <th colSpan="3">Proatividade</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td width="33.333%">Limpo</td>
                            <td width="33.333%">Sujo</td>
                            <td width="33.333%">Crítico</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      CNC
                    </td>
                    <td>
                      <table cellSpacing="0" border="1" className="bfs_subtable">
                        <thead>
                          <tr>
                            <th colSpan="3">Responsividade</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td width="49%">Sim</td>
                            <td width="49%">Não</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              TOTAL DE FISCALIZAÇÕES
            </td>
            <td style={{ borderRight: '1px solid' }}>
              ACIC
            </td>
          </tr>
          <tr className="background">
            <td colSpan="4" style={{ borderRight: '1px solid' }}>
              Regulares Escalonados
            </td>
          </tr>

          <LinhasModalidade lista={escalonado} tituloSubtotal="Subtotal Regulares Escalonados" />

          <tr className="background">
            <td colSpan="4" style={{ borderRight: '1px solid' }}>
              Regulares Demandantes
            </td>
          </tr>

          <LinhasModalidade lista={demandante} tituloSubtotal="Subtotal Regulares Demandantes" />

          <LinhaFiscalizacao
            negrito
            className="background"
            titulo="Total"
            valores={(campo) => somar(regulares, campo)}
            qntBFS={somar(regulares, 'qntBFS')}
            qntACIC={somar(regulares, 'qntACIC')}
          />
        </tbody>
      </table>
      <table border="1">
        <tbody>
          <tr>
            <td style={{ width: '41.3%' }}><strong>Regulares Próprios</strong></td>
            <td style={{ width: '19%' }}>
              <table cellSpacing="0" border="1" className="bfs_subtable">
                <tbody>
                  <tr>
                    <td>
                      <table cellSpacing="0" className="bfs_subtable">
                        <thead>
                          <tr>
                            <th colSpan="4">Proatividade</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td width="24.8%">Conforme</td>
                            <td width="25%">Não Conforme</td>
                            <td width="25%">BFS</td>
                            <td width="24.9%">ACIC</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td className="bfs_text-center" style={{ borderRight: '1px solid' }}></td>
          </tr>

          {outros.map((tipoServico) => (
            <tr key={tipoServico.idTipoServico}>
              <td>{tipoServico.tipoServico}</td>
              <td>
                <table cellSpacing="0" className="bfs_subtable-result">
                  <tbody>
                    <tr>
                      <td width="25%">{tipoServico.qntConforme}</td>
                      <td width="25%">{tipoServico.qntNaoConforme}</td>
                      <td width="25%">{(tipoServico.qntConforme || 0) + (tipoServico.qntNaoConforme || 0)}</td>
                      <td width="24.9%">{tipoServico.qntTotalOS}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td colSpan="2" style={{ borderRight: '1px solid' }}></td>
            </tr>
          ))}

          {outros.length > 0 && (
            <tr>
              <td style={{ textAlign: 'left', fontWeight: 'bold', paddingRight: '10px', background: '#ccc' }}>Total</td>
              <td colSpan="4" style={{ borderRight: '1px solid' }}>
                <table cellSpacing="0" className="bfs_subtable-result">
                  <tbody>
                    <tr>
                      <td width="23%">
                        <table className="bfs_subtable-result">
                          <tbody>
                            <tr>
                              <td style={{ width: '25%', background: '#ccc' }}>{totalConforme}</td>
                              <td style={{ width: '24.9%', background: '#ccc' }}>{totalNaoConforme}</td>
                              <td style={{ width: '24.9%', background: '#ccc' }}>{totalConforme + totalNaoConforme}</td>
                              <td style={{ width: '24.7%', background: '#ccc' }}>{somar(outros, 'qntTotalOS')}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td width="48%" style={{ background: '#ccc' }}>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Totalizadores qntBFS={qntTotalBFS} qntVistorias={qntTotalVistorias} />
    </>
  );
}
